<template>
  <div class="tito-block-alert tito-alert-light-warning" role="alert">
    <font-awesome-icon
      :icon="['fas', 'exclamation-triangle']"
      class="text-warning"
    />
    <span
      v-html="
        $t('views.registrations._form.email_not_authorized', locale, {
          href: `mailto:${contactEmail}`,
        })
      "
    />
  </div>
</template>

<script>
export default {
  props: ["locale", "contactEmail"],
};
</script>
